import type { CountryCode } from '@hotjar/country-lib';
import { getTimezoneOffset } from 'date-fns-tz';

const getPreferredLocaleByCountry = (code: string | undefined): string => {
  if (code === undefined) {
    return 'en';
  }
  return `en-${code}`;
};

/**
 * @description: returns date in a pretty localised format, e.g. "16 December 2022"
 */

export function prettifyDate(date: string | number | undefined, country?: CountryCode): string {
  if (date === undefined) {
    return '';
  }

  const { language } = window.navigator;
  /**
   * if the language is something like en-DE or es-ES we want to keep it in english (until we have translations)
   * but allow to us the preferred format i.e. DE/ES
   */
  const locale = getPreferredLocaleByCountry(language.split('-')[1] ?? country);

  return new Date(date).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function convertDateToUtc(date: Date): Date {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  date.setTime(date.getTime() - getTimezoneOffset(tz));
  return date;
}
